import RangeSlider from "Components/RangeSlider";
import React, { useState } from "react";

const PlanscreenSlider = React.memo(({ onChange }) => {
    const [value, setValue] = useState(0);

    const handleChange = (value) => {
        setValue(value);
        onChange?.(value);
    };

    return (
        <div className="d-flex align-items-center">
            <RangeSlider
                min={0}
                max={100}
                value={value}
                onChange={handleChange}
                className="planscreen-range-slider"
                step={1}
                style={{ width: "200px" }}
            />
        </div>
    );
});

export default PlanscreenSlider;